module.exports = __webpack_public_path__ + "img/car-31.c0f24ec5.jpg";